module.exports = __webpack_public_path__ + "img/business-bg2.8da7bc40.jpg";